import { useLocation } from 'react-router-dom';
import { LifeGenericResult } from '../../components';
import { useTranslation } from 'react-i18next';

export const LifePageNotFound = () => {
  const { t } = useTranslation();
  const location = useLocation() as {
    state: {
      defaultTo?: string;
      defaultLabel?: string;
    };
  };
  return (
    <LifeGenericResult
      status="404"
      title={t('common.pageNotFound')}
      defaultTo={location?.state?.defaultTo}
      defaultLabel={location?.state?.defaultLabel}
    />
  );
};
